import { apiInstance, handleApiError } from "./InstanceApi";

export const UploadBotIcon = async (file) => {
    try {
      const formData = new FormData();
      formData.append('img', file);
  
      const response = await apiInstance.post('agent/upload-bot-icon', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  };

  export const UploadThumb = async (file) => {
    try {
      const formData = new FormData();
      formData.append('img_thumb', file);
  
      const response = await apiInstance.post('agent/upload-thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  };

  
  